"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importDefault(require("react"));
var RemoveDocument_1 = __importDefault(require("./RemoveDocument"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var UploadedDocument = function (_a) {
    var documentTitle = _a.documentTitle, deleteDocument = _a.deleteDocument, documentId = _a.documentId, status = _a.status;
    var data = (0, swr_hooks_1.useKYCStatus)().data;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", null,
            react_1.default.createElement(image_1.default, { className: styles_module_scss_1.default.icon, src: "/img/icons/docIcon.svg", width: 16, height: 20, alt: "info" }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, documentTitle)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.btns },
            react_1.default.createElement(image_1.default, { className: styles_module_scss_1.default.status, src: "/img/icons/doc-status/".concat(status, ".svg"), width: 20, height: 20, alt: status }),
            (data === null || data === void 0 ? void 0 : data.status) !== swr_hooks_1.KYC_STATUS.VERIFIED ? (react_1.default.createElement(RemoveDocument_1.default, { onClick: function () {
                    deleteDocument({ id: documentId });
                } })) : null)));
};
exports.default = UploadedDocument;
